module.exports = __webpack_public_path__ + "media/images/uzi/icon-2a261215174064008f8dd3bb34c3b527.png";